import { Typography, Collapse } from 'antd';
import styles from './Title.module.css';

const { Panel } = Collapse;

const Title = (props) => {
  const getImage = (props) => {
    return props.image ? <img src={props.image} alt="Equipa" style={{ height: '27px', width: '43px' }}></img> : '';
  };
  return (
    <Typography.Title className={`${styles.title} ${!props.isHome ? styles['not-home'] : ''}`} style={props.style}>
      <span>{props.label}</span>
      <span style={{marginLeft: '15px'}}>{getImage(props)}</span>
    </Typography.Title>
  );
};

export default Title;
